export default {
    rnCallbackFlag: false,
    hotSaleList: [],
    iosDecodePhone: "", //ios完整手机号
    appVerInfo: null, //current app version
    appVersion: '', //current app version
    tpUser: false, //是否托盘用户
    userState: 1, //用户状态 1正常 2，3待审核，4待完善，9被驳回
    userIdentity: '', //用户身份 1服务商 2渠道商 3都不是 默认置空，避免页面title中间态
    userMail: '', //用户邮箱
    userInfo: {}, //用户信息，包括用户状态、用户Pin、邮箱、行业ID等
    isFirstLevelPage: false, //当前页面是否是一级页面
    darkmode: false,   //是否是暗黑模式
    isHideHeader: true, //是否隐藏返回头，保证头从无到有
}


// WEBPACK FOOTER //
// ./src/store/state.js